import CVWebScreen from './index.web';

export default function CustomizeWebScreen() {
  return <CVWebScreen initialCustomizeOpen />;
}
